module.exports = __webpack_public_path__ + "media/img/icons/search-8aa4478c11f857ec3cb235e9705b3e1b.svg";